import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function HalloumiSpinachCurry() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Halloumi Spinach Curry</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>2 large sweet potatoes,
        peeled and chopped<br></br>1 (14.5 ounce) can diced tomatoes<br></br>3
        teaspoons curry powder<br></br>2 teaspoons chili powder<br></br>1
        teaspoon ground cumin<br></br>1 (14 ounce) can coconut milk<br></br>1 (8
        ounce) package fresh spinach<br></br>½ diced green chile pepper, or to
        taste<br></br>1 cube vegetable bouillon<br></br>2 teaspoons chili jam
        (Optional)<br></br>1 (8.8 ounce) package halloumi cheese, sliced
        <br></br>1 (14 ounce) can chickpeas, drained<br></br>
      </Typography>

      <Typography>
        Place sweet potatoes into a large pot and cover with water; bring to a
        boil. <br></br>
        Cook until tender, about 6 minutes. <br></br>
        Drain.<br></br>
        <br></br>
        Combine sweet potatoes, tomatoes, curry powder, chili powder, and cumin
        in a saucepan over medium heat and bring to a simmer. <br></br>
        Add coconut milk, spinach, chile pepper, bouillon cube, and chili jam.{" "}
        <br></br>
        Simmer until curry starts to thicken and has cooked down a little, 15 to
        20 minutes.<br></br>
        <br></br>
        Meanwhile, fry halloumi in a skillet over medium heat until browned, 4
        to 6 minutes. <br></br>
        Add cooked halloumi and chickpeas to curry and heat through, about 5
        minutes.<br></br>
      </Typography>
    </Card>
  );
}
